import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

const NumberInput = ({ control, name, label, required, min, error, helperText, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ 
        required: required && 'Campo obrigatório',
        min: {
          value: min || 0,
          message: `O valor mínimo é ${min || 0}`
        }
      }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          type="number"
          fullWidth
          error={error || !!fieldState.error}
          helperText={fieldState.error?.message || helperText}
          InputLabelProps={{ shrink: true }}
          inputProps={{ 
            min: min || 0,
            ...props.inputProps
          }}
          onChange={(e) => {
            const value = parseInt(e.target.value, 10);
            field.onChange(isNaN(value) ? '' : value);
          }}
        />
      )}
    />
  );
};

NumberInput.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  min: PropTypes.number,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  inputProps: PropTypes.object
};

export default NumberInput;